import script from "./AnnotationToolViewingMode3DControls.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnotationToolViewingMode3DControls.vue?vue&type=script&setup=true&lang=js"

import "./AnnotationToolViewingMode3DControls.vue?vue&type=style&index=0&id=008c6ff6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008c6ff6"]])

export default __exports__